export default __webpack_public_path__ + "static/media/logos-globo-mais-nsc.c00f620a.png";